import { c as _c } from "react/compiler-runtime";
import { Box, Button, HStack, IconButton } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { parseAsString, useQueryState } from 'nuqs';
import React, { FC } from 'react';
import { LuX } from 'react-icons/lu';
import { MdOutlineOpenInNew } from 'react-icons/md';
type InvestorSearchToolbarProps = {
  investorProfileId?: string;
};
export const InvestorSearchToolbar: FC<InvestorSearchToolbarProps> = props => {
  const $ = _c(17);
  const layout = useParentAppLayout();
  const [investorProfileId, setInvestorProfileId] = useQueryState("investorProfileId", parseAsString);
  const {
    activeContainerWidth
  } = useBreakpointContext();
  const t0 = activeContainerWidth || "full";
  let t1;
  if ($[0] !== investorProfileId || $[1] !== layout || $[2] !== setInvestorProfileId) {
    t1 = () => {
      if (investorProfileId) {
        setInvestorProfileId(null);
      }
      layout.closePanel("investor-search-aside");
    };
    $[0] = investorProfileId;
    $[1] = layout;
    $[2] = setInvestorProfileId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LuX />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <IconButton aria-label="Toggle Aside" bgColor="whiteAlpha.100" borderRadius={4} size="sm" variant="ghost" onClick={t1}>{t2}</IconButton>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box flexGrow={1} padding="0.5em">Profile</Box>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `/investors/${props.investorProfileId || investorProfileId}`;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MdOutlineOpenInNew />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <Button asChild={true} size="sm" variant="outline"><NextLink href={t5} target="_blank">View Profile{t6}</NextLink></Button>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <HStack flexGrow={1} gap={1} justify="flex-start">{t3}{t4}{t7}</HStack>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t0 || $[15] !== t8) {
    t9 = <Box marginBottom="3.5em" width="full"><HStack align="center" backdropFilter="blur(1em)" bgColor="blackAlpha.500" borderBottom="1px solid rgba(255,255,255,.1)" gap={0} height="3.5em" justify="flex-start" paddingX={4} position="absolute" width={t0} zIndex={99}>{t8}</HStack></Box>;
    $[14] = t0;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};